import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { tipu, englishWritingBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const EnglishWriting = () => {
  // ================ Course Module start here ==================
  const [showQuestionOne, setShowQuestionOne] = useState(true);
  const [showQuestionTwo, setShowQuestionTwo] = useState(false);
  const [showQuestionThree, setShowQuestionThree] = useState(false);
  const [showQuestionFour, setShowQuestionFour] = useState(false);
  const [showQuestionFive, setShowQuestionFive] = useState(false);

  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>English Writing - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="English Writing" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des="This short course is for those who want to improve their English writing and grammar skills in a short period of time. This course is suitable for anyone who is a student, working."
            instructorName="Masud Parvej Tipu"
            instructorTitle="Sr. Instructor, English"
            instructorImg={tipu}
            classTitle="Regular Class"
            classNo="24"
            langClubTitle="LANGUAGE CLUB"
            langClubNo="12"
            debate="Examination"
            supportTitle="SUPPORT"
            support="24/7"
            bg={englishWritingBg}
          />

          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why English Writing course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Good skills in English Grammar will come.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Can do freehand writing accurately.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    It will be very helpful for freelancers.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Writing skills will come in any school, college, university,
                    or job exam.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    The foundation of English will be strong which will enable
                    you to do well in future English language tests like SAT,
                    IELTS, TOEFL, GRE, GMAT, etc. with little preparation.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Course Materials :
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  As this course is for all classes, we have designed the
                  syllabus of this course to suit them.
                </p>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    English Grammar (Parts of speech, Tense, Voice,
                    Simple/Complex/Compound)
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Punctuation & Capitalization.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Discourse Markers & Linkers for Writing.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Freehand writing exercise
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Writing Structure
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Types of Writing
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Writing formats and Business letter writing
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Assignment and Feedback
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Course Facilities :
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    03 classes in a week (a practice-based class).
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Our maximum class time is at night. So, if you are a job
                    holder/ student can easily join the class.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Recorded video of a live class, in case you, miss the live
                    class. We always prefer to be present in the live session.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Class notes & other materials.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    We will provide short support like this- if you have to
                    submit your presentation at your university or, office then
                    our instructor will provide you necessary tips to make the
                    best content in your presentation.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div></div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Q & A start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Questions and answers about the course:
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Question One Start here ============== */}
            <div>
              <h3
                onClick={() => setShowQuestionOne(!showQuestionOne)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Will the course be better online?
                {showQuestionOne ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showQuestionOne && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        We have been conducting online classes regularly since
                        Covid-19 and have successfully completed around 50+
                        batches online so far. Every student is happy with our
                        online course because they get good service but also
                        save their time and money because of online. And the jam
                        that we have to bear in Dhaka city. Our online course
                        will take more than that. Moreover, since we provide 6
                        months+ time practice opportunities online, no one has
                        any problem with the course.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Question Two Start here ============== */}
            <div>
              <h3
                onClick={() => setShowQuestionTwo(!showQuestionTwo)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Can the course fee be discounted?
                {showQuestionTwo ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showQuestionTwo && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        We do not give discounts on Course Fees & Course
                        quality. If you want to get something good, you have to
                        pay a price. Gold is never available at the emission
                        price. If someone even offers that, there must be a
                        problem.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Question Three Start here ============== */}
            <div>
              <h3
                onClick={() => setShowQuestionThree(!showQuestionThree)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                I will do it offline. Is there any chance?
                {showQuestionThree ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showQuestionThree && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Yes, it can be done. Anyone can do this course either
                        offline or online.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Question Four Start here ============== */}
            <div>
              <h3
                onClick={() => setShowQuestionFour(!showQuestionFour)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Can I repeat the course for the same fee?
                {showQuestionFour ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showQuestionFour && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        No. But we will give you the opportunity to do it up to
                        3 times.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Question Five Start here ============== */}
            <div>
              <h3
                onClick={() => setShowQuestionFive(!showQuestionFive)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Will you be a group and give a separate batch?
                {showQuestionFive ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showQuestionFive && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Yes, if 80% of our batch seats come as a group or
                        corporate contract, we can provide service both online
                        and offline.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="we will train you about the appropriate Email Writing which may help you in many ways."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default EnglishWriting;
